import React, { useState } from "react";
import { Layout, Tabs, Row, Col } from "antd";
import { ImportOutlined, UserAddOutlined } from "@ant-design/icons";
import Login from "./login";
import Register from "./register";
import moment from "moment-jalaali";

import YourLoggedIn from "@general/yourLoggedIn";

const { Content, Header, Footer } = Layout;

function Auth() {
  const [changeLoginLabel, setChangeLoginLabel] = useState(false);
  const tabs = [
    {
      id: 1,
      label: changeLoginLabel ? "رمز" : "ورود",
      icon: <ImportOutlined />,
      children: (
        <Login onForgetPass={() => setChangeLoginLabel(!changeLoginLabel)} />
      ),
    },
    {
      id: 2,
      label: "ثبت نام",
      icon: <UserAddOutlined />,
      children: <Register />,
    },
  ];
  const accessToken = localStorage.getItem("accessToken");

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header className="site-header" style={{ color: "#dddddde6", textAlign: "center", fontWeight: 500, fontSize: 18 }}>به سامانه صفاتک خوش آمدید</Header>
      <Layout className="site-layout">
        <Content
          className="site-layout-background"
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
          }}
        >
          {!accessToken ? (
            <div className="auth-tabs">

              <Tabs
                centered
                size="large"
                defaultActiveKey="1"
                items={tabs.map((tab, i) => {
                  return {
                    label: (
                      <span>
                        {tab.icon} {tab.label}
                      </span>
                    ),
                    key: tab.id,
                    children: tab.children,
                  };
                })}
              />
            </div>
          ) : (
            <YourLoggedIn />
          )}
        </Content>
        <Footer
          style={{
            textAlign: "center",
            direction: "ltr",
          }}
        >
          <Row>
            <h3 style={{ fontWeight: 500, color: "white" }}>پیوندها: </h3>
          </Row>
          <Row style={{ marginBottom: 5 }}>
            <a href="https://safatec.ir/" target="_blank" rel="noopener noreferrer">سایت صفاتک</a>
          </Row>
          <Row>
            <a href="https://safatec.ir/%d8%aa%d9%85%d8%a7%d8%b3-%d8%a8%d8%a7-%d9%85%d8%a7/" target="_blank" rel="noopener noreferrer">ارتباط با ما</a>
          </Row>
          <Row style={{ marginBottom: 5 }}>
            <a href="https://link.safatec.ir" target="_blank" rel="noopener noreferrer">شبکه ارتباطی اعضای صفاتک</a>
          </Row>
          <Row>
            <div
              style={{
                textAlign: "center",
                direction: "ltr",
                margin: "auto",
              }}
            >
              SafaTec ©{moment(Date.now()).year()}
            </div>
          </Row>
        </Footer>
      </Layout>

    </Layout>
  );
}

export default Auth;
